import { ArrowsLeftRightIcon } from '@/components/icons/arrowsLeftRight'
import { BankIcon } from '@/components/icons/bank'
import { CardTickIcon } from '@/components/icons/cardTick'
import { ChartUpIcon } from '@/components/icons/chartUp'
import { CoinsIcon } from '@/components/icons/coins'
import type { IconProps } from '@/components/icons/common'
import { DropIcon } from '@/components/icons/drop'
import { FlaskIcon } from '@/components/icons/flask'
import { LockIcon } from '@/components/icons/lock'
import { MoneyBagIcon } from '@/components/icons/moneyBag'
import { PercentageCircleIcon } from '@/components/icons/percentageCircle'
import { PlantIcon } from '@/components/icons/plant'
import { RepeatIcon } from '@/components/icons/repeat'
import { RiskCoverIcon } from '@/components/icons/riskCover'
import { ShieldIcon } from '@/components/icons/shield'
import { SupportDollarIcon } from '@/components/icons/supportDollar'
import { TableIcon } from '@/components/icons/table'
import { TickCircleIcon } from '@/components/icons/tickCircle'
import { UsersIcon } from '@/components/icons/users'
import type { ComponentType } from 'react'

export function getCategoryIcon(category: string): ComponentType<IconProps> {
  switch (category.toLowerCase()) {
    case 'basis trading':
      return ChartUpIcon
    case 'bridging':
      return ArrowsLeftRightIcon
    case 'cdp':
      return LockIcon
    case 'credit':
      return CardTickIcon
    case 'lending':
      return SupportDollarIcon
    case 'liquid staking':
      return DropIcon
    case 'market making':
      return MoneyBagIcon
    case 'rwa':
      return BankIcon
    case 'synthetic':
      return FlaskIcon
    case 'yield aggregator':
      return PlantIcon
    case 'direct protocol lending':
      return CoinsIcon
    case 'curated lending':
      return TickCircleIcon
    case 'shared lending pool':
      return UsersIcon
    case 'isolated market':
      return TableIcon
    case 'dex-integrated lending':
      return RepeatIcon
    case 'protocol savings rate':
      return PercentageCircleIcon
    case 'safety module':
      return ShieldIcon
    case 'risk cover':
      return RiskCoverIcon
    default:
      return ChartUpIcon
  }
}
